
const WhyMSSPsChooseSection = () => {
  const benefits = [
    {
      title: "Built-in multi-tenancy",
      description: "Manage multiple clients seamlessly with native multi-tenant architecture"
    },
    {
      title: "Eighty percent reduction in false positives",
      description: "AI-powered analysis dramatically reduces noise and alert fatigue"
    },
    {
      title: "Faster onboarding and automated runbooks",
      description: "Streamlined client onboarding with intelligent automation"
    },
    {
      title: "Unified visibility across endpoints, cloud, and identity",
      description: "Complete security coverage with centralized management"
    },
    {
      title: "White-labeled under your brand",
      description: "Deliver services under your own brand with full customization"
    },
    {
      title: "No more chasing alerts - deliver outcomes",
      description: "Focus on strategic security outcomes rather than reactive alert management"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Top section with "Grow Your MSSP Business" */}
          <div className="mb-16 bg-gradient-to-r from-[#8932c8] to-[#b87ade] rounded-3xl p-8 md:p-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Grow Your MSSP Business with AI-Driven XDR</h2>
            <p className="text-lg md:text-xl text-white/90 max-w-4xl mx-auto">
              Expand into new markets and increase recurring revenue with Spharaka. Our agentic AI platform empowers MSSPs to deliver faster, smarter, and scalable managed security services — fully branded and built for growth.
            </p>
          </div>

          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold mb-6">
              Why MSSPs Choose 
              <span className="bg-gradient-to-r from-[#8932c8] to-[#b87ade] bg-clip-text text-transparent"> Spharaka</span>
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Transform your security operations with AI-powered capabilities that scale your business
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group"
              >
                <div className="flex items-start gap-6">
                  <div className="flex-1">
                    <h4 className="text-xl font-bold mb-3 text-gray-900">{benefit.title}</h4>
                    <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyMSSPsChooseSection;
